LoginModalDirective.$inject = ['auth', 'api'];
function LoginModalDirective(auth, api) {
    return {
        template: require('./views/login-modal.html'),
        link: function (scope, element, attrs) {
            scope.active = false;
            scope.errors = null;
            scope.currentCompany = null;
            scope.$watch(function getAuthToken() {
                return auth.getToken();
            }, function (token) {
                if (!token) {
                    scope.active = true;
                    scope.username = null;
                    scope.password = null;
                    scope.currentCompany = null;
                }
                else {
                    scope.active = false;
                    api.get('/company/self').then(function (response) {
                        scope.currentCompany = response[0];
                    });
                }
            });
            scope.login = function () {
                scope.errors = null;
                api.login(scope.username, scope.password).then(function (response) {
                    auth.setToken(response.token);
                    auth.resolveIdentity();
                    scope.active = false;
                }, function (error) {
                    scope.errors = error.data;
                });
            };
        }
    };
}
angular.module('profumo.core.main.login', [])
    .directive('loginModal', LoginModalDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/main/login-modal.ts
// module id = 450
// module chunks = 0